import cl from './AppModal.module.css'

const AppModal = ({children, visible}) => {

    const rootClasses = [cl.appModal]
    if (visible) {
        rootClasses.push(cl.active);
    }

    return (
        <div className={rootClasses.join(' ')}>
            <div className={cl.appModal__content}>
                {children}
            </div>
        </div>
    )

}

export default AppModal;